import { Component, input, model, output } from '@angular/core';
import { PrimengImports } from '../../../../../shared/primeng/primeng.imports';

@Component({
  selector: 'krc-submit-error-dialog',
  standalone: true,
  imports: [PrimengImports],
  templateUrl: './submit-error-dialog.component.html',
  styleUrl: './submit-error-dialog.component.scss',
})
export class SubmitErrorDialogComponent {
  readonly visible = model(false);
  readonly isSaving = input(false);

  readonly contactSupport = output<void>();
  readonly retry = output<void>();
}
